export default {
  path: ":alias/teachers",
  component: resolve => require(["@/views/teachers"], resolve),
  children: [
    {
      path: "list",
      component: resolve => require(["@/views/teachers/list"], resolve)
    }
  ]
};
